import AutoAwesomeOutlined from "@mui/icons-material/AutoAwesomeOutlined";
import { Button } from "@mui/material";
import { useUpdateEffect } from "@react-hookz/web";
import { useCallback, useState } from "react";
import { usePrompts } from "../multiformat/hooks/use-prompts";
import { SURVEY_FORMAT } from "./content-type-select";

import type { FC } from "react";

// Copied from Listen's dashboard prompt, since Survey isn't a multiformat content type
const SURVEY_INSPIRE_ME_PROMPTS = [
  "Create a pulse survey for a remote team",
  "Design a feedback survey for a new product launch",
  "Draft a survey to assess employee engagement in a hybrid work environment",
  "Create a survey to gather feedback on company culture",
  "Generate a survey to evaluate leadership effectiveness",
  "Design a survey to measure job satisfaction in a customer service team",
  "Draft a survey to assess training and development needs in an organization",
  "Create a survey to gather feedback on workplace diversity and inclusion",
  "Generate a survey to evaluate the effectiveness of internal communication",
  "Design a survey to assess employee well-being and mental health",
  "Draft a survey to gather feedback on remote work policies",
  "Create a survey to evaluate the onboarding process for new hires",
  "Generate a survey to assess team collaboration and dynamics",
  "Design a survey to measure employee recognition and rewards",
  "Draft a survey to gather feedback on performance appraisal processes",
  "Create a survey to evaluate the effectiveness of company values",
  "Generate a survey to assess the impact of organizational change",
  "Design a survey to measure employee motivation and engagement",
  "Draft a survey to gather feedback on work-life balance initiatives",
];

export const InspireMeButton: FC<{ onInspire: (prompt: string) => void; format: string }> = ({
  onInspire,
  format,
}) => {
  const { loading, error, data } = usePrompts();
  const isSurvey = format === SURVEY_FORMAT;
  const prompts = isSurvey ? SURVEY_INSPIRE_ME_PROMPTS : data?.[format];

  const [inspirePosition, setInspirePosition] = useState<number | undefined>();

  useUpdateEffect(() => {
    setInspirePosition(0);
  }, [format]);

  const handleInspire = useCallback(() => {
    if (!prompts) {
      return;
    }

    const promptsWithoutCurrentPrompt = prompts?.filter((_, index) => index !== inspirePosition);

    const prompt =
      promptsWithoutCurrentPrompt[Math.floor(Math.random() * promptsWithoutCurrentPrompt.length)]!;
    const promptIndex = prompts.indexOf(prompt);

    onInspire(prompt);
    setInspirePosition(promptIndex);
  }, [prompts, onInspire, inspirePosition]);

  if (error && !isSurvey) {
    return null;
  }

  return (
    <Button
      size="small"
      variant="text"
      onClick={handleInspire}
      color="primary"
      disabled={loading && !isSurvey}
      startIcon={<AutoAwesomeOutlined />}
      data-analytics-id="create-content-inspire-me"
    >
      Inspire me
    </Button>
  );
};
